import { AnalyticsInsightsHomeController } from './analytics-insights-home.controller'

function analyticsInsightsHome () {
  return {
    restrict: 'E',
    scope: {
      noData: '='
    },
    templateUrl: '/analytics/directives/analytics-insights-home/analytics-insights-home-directive.html?$$REVISION$$',
    controller: AnalyticsInsightsHomeController
  }
}

export { analyticsInsightsHome }
